import React from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Typography,
  Button,
} from '@mui/material';
import api from '../../services/api';
import SwalWithA11yFix from '../../services/swalConfig';

const TestHistory = ({ tests, onUpdate }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'success';
      case 'in-progress':
        return 'warning';
      case 'assigned':
        return 'info';
      case 'cancelled':
        return 'error';
      default:
        return 'default';
    }
  };

  const handleDownloadResult = async (testId) => {
    try {
      const response = await api.get(`/patient/tests/${testId}/download-result`, { responseType: 'blob' });
      const contentDisposition = response.headers?.['content-disposition'] || '';
      const fileNameMatch =
        contentDisposition.match(/filename\*=UTF-8''([^;]+)/i) ||
        contentDisposition.match(/filename="?([^"]+)"?/i);
      const fileName = fileNameMatch?.[1] ? decodeURIComponent(fileNameMatch[1]) : `lab-report-${testId}`;
      const blobUrl = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      SwalWithA11yFix({
        icon: 'error',
        title: 'Download failed',
        text: error.response?.data?.message || 'Unable to download report.',
      });
    }
  };

  return (
    <Box>
      <TableContainer 
        component={Paper}
        sx={{
          maxWidth: '100%',
          overflowX: 'auto',
          backgroundColor: 'white',
          borderRadius: 3,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Test Name</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Test Date</TableCell>
              <TableCell>Practitioner</TableCell>
              <TableCell>Remarks</TableCell>
              <TableCell>Report</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tests.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Typography variant="body2" color="text.secondary">
                    No tests found
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              tests.map((test) => (
                <TableRow key={test._id}>
                  <TableCell>{test.test?.name}</TableCell>
                  <TableCell>
                    <Chip
                      label={test.status}
                      color={getStatusColor(test.status)}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    {test.testDate
                      ? new Date(test.testDate).toLocaleDateString()
                      : '-'}
                  </TableCell>
                  <TableCell>
                    {test.practitioner
                      ? `${test.practitioner.firstName} ${test.practitioner.lastName}`
                      : '-'}
                  </TableCell>
                  <TableCell>{test.practitionerRemarks || '-'}</TableCell>
                  <TableCell>
                    <Button
                      size="small"
                      variant="outlined"
                      disabled={!test.visibleToPatient || !test.fileUrl}
                      onClick={() => handleDownloadResult(test._id)}
                      sx={{ mr: 1 }}
                    >
                      Download
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TestHistory;

